export function getLocalStorageProvider(): {
    getItem: ((key: string) => Promise<unknown>) &
        (<T>(key: string) => Promise<T>);
    setItem: (key: string, item: string | object | boolean) => Promise<unknown>;
    removeItem: (key: string) => Promise<unknown>;
} {
    return {
        getItem: async <T = string | null>(key: string) =>
            JSON.parse(localStorage.getItem(key) || 'null') || (undefined as T),
        setItem: async (key, value) =>
            localStorage.setItem(key, JSON.stringify(value)),
        removeItem: async (key) => localStorage.removeItem(key),
    };
}
